/**
 * Wellbeing endpoints: the server copy of the focus log, and the thought for
 * today. Mood check-ins and the worry dump have no endpoint on purpose - they
 * never leave the device.
 */
import type {
  FocusBlockListResponse,
  FocusBlockSyncResponse,
  FocusBlockUpload,
  WellbeingThought,
} from '@/types/api';
import { apiClient } from './client';

export const wellbeingApi = {
  listFocusBlocks: (since: string) =>
    apiClient.get<FocusBlockListResponse>(
      `/wellbeing/focus-blocks?since=${encodeURIComponent(since)}`
    ),

  /** Idempotent: replaying a block, or re-sending it with a recap, is safe. */
  syncFocusBlocks: (blocks: FocusBlockUpload[]) =>
    apiClient.post<FocusBlockSyncResponse>('/wellbeing/focus-blocks/sync', {
      blocks,
    }),

  /** `date` is the student's LOCAL date, so the thought turns at their midnight. */
  getThought: (date: string) =>
    apiClient.get<WellbeingThought>(`/wellbeing/thought?date=${date}`),
};
